module.exports = __webpack_public_path__ + "img/beijing.5568b5e4.png";